/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

export abstract class FormFieldControl {
  abstract setHasError(hasError: boolean): void;
}
